import { ChevronRight, Clock3, LockKeyhole } from 'lucide-react'
import type { ComponentType, ReactNode, SVGProps } from 'react'
import { Link } from 'react-router-dom'

type IconType = ComponentType<SVGProps<SVGSVGElement>>

export function Emblem({ icon: Icon, tone = 'burgundy' }: { icon: IconType; tone?: 'burgundy' | 'gold' | 'sage' }) {
  return <span className={`emblem emblem--${tone}`}><Icon /></span>
}

export function PlannedButton({ children, reason = '此功能將於後續批次接線' }: { children: ReactNode; reason?: string }) {
  return <button className="button button--planned" disabled title={reason}><Clock3 />{children}<span>規劃中</span></button>
}

export function ActionLink({ to, children, className = '' }: { to: string; children: ReactNode; className?: string }) {
  return <Link className={`action-link ${className}`} to={to}>{children}<ChevronRight /></Link>
}

export function LockedCard({ title, description }: { title: string; description: string }) {
  return <article className="soft-card locked-card"><LockKeyhole /><div><h3>{title}</h3><p>{description}</p></div><span>尚未解鎖</span></article>
}

export function Meter({ value, label }: { value: number; label?: string }) {
  return <div className="meter" aria-label={label ?? `進度 ${value}%`}><span style={{ width: `${Math.max(0, Math.min(100, value))}%` }} /></div>
}

export function PageIntro({ eyebrow, title, description, icon: Icon }: { eyebrow?: string; title: string; description: string; icon?: IconType }) {
  return (
    <section className="page-intro">
      {Icon && <Emblem icon={Icon} />}
      <div>{eyebrow && <p className="eyebrow">{eyebrow}</p>}<h2>{title}</h2><p>{description}</p></div>
    </section>
  )
}
